var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-manager-container" }, [
    _vm.userInfo !== null
      ? _c(
          "div",
          [
            _c("new-device-create", {
              attrs: { reloadData: _vm.loadData, userId: _vm.userInfo.id },
            }),
            _vm._v(" "),
            _c("show-devices", {
              ref: "showDevicesRef",
              attrs: { userId: _vm.userInfo.id },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }